import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-under-development-actions',
  templateUrl: './under-development-actions.component.html',
  styleUrls: ['./under-development-actions.component.css']
})
export class UnderDevelopmentActionsComponent {
  @Output() homeRequested = new EventEmitter<void>();
  @Output() refreshRequested = new EventEmitter<void>();
}
